import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0AvatarModule } from '@factorialco/f0-react'

import i18n from 'modules/core/lib/i18n'

import CrossellingSelector from 'modules/upsell/components/SelfUpsell/CheckoutModal/CrossellingSelector'
import FeaturesList from 'modules/upsell/components/SelfUpsell/CheckoutModal/FeaturesList'
import { moduleAvailableToModuleId } from 'modules/upsell/lib/moduleIcons'
import type Plan from 'modules/upsell/lib/selfUpsell/plans/Plan'
import {
  BUSINESS_VARIANT,
  SIX_MONTH_PERIOD,
} from 'modules/upsell/lib/selfUpsell/plans/utils'
import { useSelfUpsellContext } from 'modules/upsell/store/SelfUpsellProvider'

type ApiDiscount = {
  discountPercentage: number
  amount: number
  discountType: string
  lineItemId?: string
  period?: number
  periodUnit?: string
}

type LeftSectionProps = {
  addon: Plan
  variant: string | undefined
  step: string
  iconName: string
  crossSellingAddons?: Plan[] | undefined
  mandatoryCrossSellingAddons?: Plan[] | undefined
  selectedCrossSellingAddons?: Plan[]
  setSelectedCrossSellingAddons?: (crossSellingAddons: Plan[] | ((prev: Plan[]) => Plan[])) => void
  discounts?: ApiDiscount[] | undefined
  isLoadingDiscounts?: boolean
  moduleTranslatedName?: string
}

const LeftSection = ({
  addon,
  variant,
  step,
  iconName,
  crossSellingAddons,
  mandatoryCrossSellingAddons,
  selectedCrossSellingAddons,
  setSelectedCrossSellingAddons,
  discounts,
  isLoadingDiscounts = false,
  moduleTranslatedName,
}: LeftSectionProps) => {
  const showFeatures = step === 'first'
  const showCrossSellingAddons = step === 'second'
  const moduleId = moduleAvailableToModuleId(iconName)
  const { period, shouldBypassSelfUpsell } = useSelfUpsellContext()
  const isValidSubscription = shouldBypassSelfUpsell || period !== SIX_MONTH_PERIOD

  return (
    <Box
      padding="s24"
      paddingBottom="s0"
      background="grey100"
      borderRadius={{
        topLeft: 'abs016',
        bottomLeft: 'abs016',
      }}
      style={{
        width: '40%',
        position: 'relative',
      }}
    >
      <Box gap="s16" paddingBottom="s16">
        <F0AvatarModule module={moduleId} size="lg" />
        <Box gap="s6">
          {step === 'first' && (
            <>
              <Text size="400" color="grey1000" weight="semibold">
                {moduleTranslatedName || addon.title}
              </Text>
              <Text.Normal size="200" color="grey700">
                {addon.description}
              </Text.Normal>
            </>
          )}
          {step === 'second' && (
            <>
              <Text size="400" color="grey1000" weight="semibold">
                {i18n.t('self_upsell.second_step.left_side.title')}
              </Text>
              <Text.Normal size="200" color="grey700">
                {i18n.t('self_upsell.second_step.left_side.description')}
              </Text.Normal>
            </>
          )}
        </Box>
      </Box>
      <Box
        paddingBottom="s24"
        style={{
          overflowY: 'auto',
          scrollbarWidth: 'none',
        }}
      >
        {showFeatures && (
          <FeaturesList addon={addon} selectedVariant={variant || BUSINESS_VARIANT} />
        )}
        {showCrossSellingAddons && crossSellingAddons && (
          <Box gap="s8">
            {mandatoryCrossSellingAddons?.map((mandatoryCrossSellingAddon) => (
              <CrossellingSelector
                crossSellingAddon={mandatoryCrossSellingAddon}
                showPrice={isValidSubscription}
                key={mandatoryCrossSellingAddon.internalTitle}
                selectedCrossSellingAddons={selectedCrossSellingAddons || []}
                setSelectedCrossSellingAddons={setSelectedCrossSellingAddons || (() => {})}
                discounts={discounts}
                isMandatory
                isLoadingDiscounts={isLoadingDiscounts}
              />
            ))}
            {crossSellingAddons.map(
              (crossSellingAddon) => (
                // Fix installation check
                // !crossSellingAdddonsInstalled.moduleStatusMap.get(crossSellingAddon.internalTitle) ? (
                <CrossellingSelector
                  crossSellingAddon={crossSellingAddon}
                  showPrice={isValidSubscription}
                  key={crossSellingAddon.internalTitle}
                  selectedCrossSellingAddons={selectedCrossSellingAddons || []}
                  setSelectedCrossSellingAddons={setSelectedCrossSellingAddons || (() => {})}
                  discounts={discounts}
                  isLoadingDiscounts={isLoadingDiscounts}
                />
              )
              // ) : null
            )}
          </Box>
        )}
      </Box>
      <Box
        borderRadius={{
          bottomLeft: 'abs016',
        }}
        style={{
          position: 'absolute',
          bottom: '0',
          left: '0',
          right: '0',
          height: '80px',
          background: 'linear-gradient(to bottom, rgba(250, 250, 250, 0), rgba(250, 250, 250, 1))',
          pointerEvents: 'none',
        }}
      />
    </Box>
  )
}

export default LeftSection
